<template>
    <div class="user-item"
         :class="{active:other_id==keys}"
         @click="selectUser">
        <el-badge :value="item.num" :hidden="item.num<=0">
            <!--<img v-if="item.info && `${item.info.avar}`.indexOf('http')>=0" class="user-head" :src="item.info.avar" alt="">
            <img v-else class="user-head" :src="`/api/v1/file/${item.info.avar}`" alt="">-->
            <img class="user-head" :src="`/api/v1/file/${userInfo.portrait}`" alt="">
        </el-badge>
        <div class="user-name">
            <div class="line-clamp-1" :title="userInfo.name">{{userInfo.name}}</div>
            <div class="f-12 color-grays line-clamp-1" style="font-weight: normal">{{userInfo.content}}</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ChartUserItem",
        props: {
            item: {
                type: Object,
                default(){
                    return {
                        info: ''
                    }
                }
            },
            other_id:{
                type: [String, Number],
                default: ''
            },
            keys:{
                type: [String, Number],
                default: ''
            }
        },
        data() {
            return {
                userInfo: {}
            }
        },
        created() {
            this.socketCache()
            this.socketSelecta()
        },
        methods: {
            selectUser() {
                this.$emit('selectUser', this.userInfo)
            },
            async socketSelecta(){
                let [e, data] = await this.$api.socketSelectaApi({other_id: this.item.id})
                this.$store.commit('initUserChartData', {id: this.item.id, msg: data.result})
            },
            async socketCache(){
                let [e, data] = await this.$api.socketCacheApi({id: this.item.id})
                this.userInfo = data.result
            },
        },
    }
</script>

<style scoped lang="less">
    .user-item {
        width: 100%;
        height: 60px;
        padding: 0 20px;
        display: flex;
        box-sizing: border-box;
        justify-content: flex-start;
        align-items: center;
        border-top: 1px solid #e2e2e2;
        cursor: pointer;

        &:hover {
            background-color: #f2f2f2;
            color: rgba(228, 70, 70, 0.99);
        }

        .user-head {
            width: 40px;
            height: 40px;
            object-fit: cover;
            border-radius: 100%;
            margin-right: 10px;
        }

        .user-name {
            font-size: 14px;
            font-weight: bold;
        }
    }

    .active {
        background-color: #f2f2f2 !important;
        color: #e44646 !important;
        font-weight: bold;
    }
</style>
